import { render } from "./FunFacts.vue?vue&type=template&id=0794eb66"
import script from "./FunFacts.vue?vue&type=script&lang=js"
export * from "./FunFacts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__